<template>
  <div>
    <div
      class="hearder-warpper"
      :class="{ isFixed, isHyaline, boxShadow: opcatiy > 0.5 }"
      :style="
        isFixed && isHyaline ? `background:rgba(255,255,255,${opcatiy})` : ''
      "
    >
      <div class="hearder-content page-width-warpper">
        <!-- <img class="logo" src="@/assets/images/logo.png" /> -->
        <ul>
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="{ active: currentIndex === index }"
            @click="navSelect(item)"
          >
            {{ item.name }}
            <template v-if="item.children">
              <div class="children">
                <p
                  :class="
                    currentIndex === index && childrenIndex === index2
                      ? 'on'
                      : ''
                  "
                  v-for="(arr, index2) in item.children"
                  :key="index2"
                  @click.stop="$router.push(arr.to)"
                >
                  <span> {{ arr.label }}</span>
                </p>
              </div>
            </template>
          </li>
        </ul>
        <div class="search-box">
          <el-input
            v-model="searchValue"
            placeholder="请输入关键字"
            @keyup.enter.native="search(searchValue)"
          />
          <i class="el-icon-search" @click="search(searchValue)"></i>
        </div>
      </div>
    </div>
    <div class="hearder-height" v-show="isFixed && !isHyaline"></div>

    <!-- 添加确认弹窗 -->
    <el-dialog
        :visible.sync="dialogVisible"
        :show-close="false"
        width="300px"
        center>
      <div class="dialog-content">
        <i class="el-icon-warning warning-icon"></i>
        <span>请输入搜索内容</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  props: {
    isFixed: {
      type: Boolean,
      default: false,
    },
    // 初始透明背景
    isHyaline: {
      type: Boolean,
      default: false,
    },
    hyalineHeight: {
      type: Number,
      default: 140,
    },
    // 渐变距离
    scrollHeight: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      opcatiy: {},
      searchValue: "",
      navList: [
        { name: "首页", to: "/" },
        { name: "协会概况", to: "/basicFacts" },
        { name: "通知公告", to: "/notice" },
        { name: "协会动态", to: "/dynamic" },
        { name: "行业资料", to: "/data" },
        { name: "专委会资讯", to: "/news" },
        { name: "政策法规", to: "/rule" },
        { name: "产品展示", to: "/product" },
        { name: "党建廉政", to: "/party" },
        { name: "铸造行情", to: "/market" },
        { name: "联系我们", to: "/contactUs" },
        // {
        //   name: "帮助中心",
        //   type: "link",
        //   flag: true,
        //   children: [
        //     // { to: "/front-bear", label: "行业智库" },
        //     { to: "/about", label: "关于我们" },
        //     { to: "/front-help", label: "帮助中心" },
        //   ],
        // },
      ],
      currentIndex: 0,
      childrenIndex: 0,
      dialogVisible: false, // 添加弹窗显示控制变量
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        let findIndex = -1;
        // console.log(this.navList)
        this.navList.some((item, index) => {
          if (
            (item.to && item.to === val.path) ||
            (item.children &&
              item.children.findIndex((f) => f.to === val.path) !== -1)
          ) {
            // if (val.fullPath === item.to) {
            findIndex = index;
            return true;
          }
        });
        // console.log(findIndex)
        this.currentIndex = findIndex;
        if (
          this.currentIndex !== -1 &&
          this.navList[this.currentIndex].children
        ) {
          this.childrenIndex = 0;
          if (val.query.code) {
            this.navList[this.currentIndex].children.some((item, index) => {
              if (item.code === val.query.code) {
                this.childrenIndex = index;
                return true;
              }
            });
          }
        } else {
          this.currentIndex = findIndex;
        }
        // if (this.currentIndex == 0) {
        //   this.currentIndex = 4
        // }
      },
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 处理滚动事件的逻辑
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= this.hyalineHeight) {
        if (scrollTop >= this.hyalineHeight + this.scrollHeight) {
          this.opcatiy = 1;
          return;
        }
        this.opcatiy = (scrollTop - this.hyalineHeight) / this.scrollHeight;
      } else {
        this.opcatiy = 0;
      }
    },
    search(title) {
      // 优化：添加搜索值空验证
      if (!title || !title.trim()) {
        this.dialogVisible = true; // 显示弹窗
        return;
      }
      this.searchValue = "";
      this.$router.replace(
        `/search?title=${title}&time=${new Date().getTime()}`
      );
    },
    navSelect(item) {
      if (item.break) {
        window.open(`${window.location.origin}${item.to}`, "_blank");
      } else if (item.children && item.type === "code") {
        this.$router.push({
          path: item.to,
          query: { code: item.children[0].code },
        });
      } else if (item.children && item.type === "link") {
        this.$router.push(item.children[0].to);
      } else {
        this.$router.push({ path: item.to });
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css


/* 弹窗样式 */
.dialog-content {
  text-align: center;
  padding: 20px 0;
}

.dialog-content .warning-icon {
  color: #e6a23c;
  font-size: 24px;
  margin-right: 10px;
}

.dialog-content span {
  font-size: 16px;
  vertical-align: middle;
}

.dialog-footer {
  text-align: center;
}

/* 椭圆形弹窗样式 */
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 auto !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 30px !important; /* 椭圆形圆角 */
  background-color: #f5f5f5 !important; /* 浅灰色背景 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

::v-deep .el-dialog__header {
  display: none; /* 隐藏头部 */
}

::v-deep .el-dialog__body {
  padding: 30px 20px;
  text-align: center;
}

::v-deep .el-dialog__footer {
  padding-bottom: 20px;
}


.hearder-height {
  height: 52px;
}
.hearder-warpper {
  margin-top: 5px;
  // background: $main-color;
  // padding-top: 12px;
  box-sizing: border-box;
  &.isFixed {
    position: fixed;
    z-index: 1111;
    top: 0;
    left: 0;
    right: 0;
    margin: 0;
  }
  &.isHyaline {
    background: none;
  }
  &.boxShadow {
    box-shadow: $box-shadow;
  }
  .hearder-content {
    background: linear-gradient(
      to bottom,
      rgba($color: $main-color, $alpha: 0.6),
      rgba($color: $main-color, $alpha: 0.9)
    );
    // width: 980px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px 0 5px;
    .logo {
      height: 50px;
      width: auto;
      display: block;
    }
    .search-box {
      margin-left: 5px;
      width: 150px;
      display: flex;
      align-items: center;
      padding: 1px 10px 1px 8px;
      background: #efefef;
      border-radius: 30px;
      .el-icon-search {
        color: $main-color;
        cursor: pointer;
      }
      ::v-deep .el-input__inner {
        padding: 0 5px;
        border: none;
        outline: none;
        background: none;
        height: 30px;
      }
    }
    ul {
      flex: 1;
      display: flex;
      // margin-left: 40px;
      // padding: 12px 0;
      justify-content: space-between;
      li {
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        position: relative;
        padding: 0 5px;
        &:last-child {
          margin-right: 0;
        }
        // &::after {
        //   content: "";
        //   position: absolute;
        //   bottom: 0;
        //   height: 3px;
        //   background: $main-color;
        //   width: 0;
        //   left: 50%;
        //   transform: translateX(-50%);
        // }
        &:hover {
          // color: $main-color;
          background: rgba($color: #fff, $alpha: 0.2);
          // .children {
          //   display: block;
          // }
          // &::after {
          //   transition: 0.5s width;
          //   width: 100%;
          // }
        }
        &.active {
          background: rgba($color: #fff, $alpha: 0.2);
          //   background: $main-color;
          //   color: $main-color;
          //   &::after {
          //     width: 100%;
          //   }
        }
        .children {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          // min-width: 90px;
          // text-align: center;
          display: none;
          text-align: center;
          background: #fff;
          z-index: 10;
          border-radius: 4px;
          overflow: hidden;
          padding: 5px 15px;
          opacity: 0.9;
          box-shadow: $box-shadow;
          p {
            line-height: 1.5;
            font-size: 14px;
            color: #333;
            cursor: pointer;
            padding: 5px 0;
            white-space: nowrap;
            // border-bottom: 1px solid #efefef;
            // &:last-child {
            //   border: none;
            // }
            &.on {
              color: $main-color;
            }
            &:hover {
              color: $main-color;
            }
          }
        }
      }
    }
  }
}
</style>
